import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { cn } from '../lib/utils';
import { typography } from '../lib/typography';

/** PageTitle or DisplayTitle owns the page's single h1; secondary roles stay sans. */
type HeadingProps = ComponentPropsWithoutRef<'h1'>;
type SectionHeadingProps = ComponentPropsWithoutRef<'h2'>;
type ParagraphProps = ComponentPropsWithoutRef<'p'>;

export const DisplayTitle = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, ...props }, ref) => (
    <h1 ref={ref} className={cn(typography.display, className)} {...props} />
  ),
);
DisplayTitle.displayName = 'DisplayTitle';

export const PageTitle = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, ...props }, ref) => (
    <h1
      ref={ref}
      className={cn(typography.pageTitle, 'min-w-0 break-words', className)}
      {...props}
    />
  ),
);
PageTitle.displayName = 'PageTitle';

export const SectionTitle = forwardRef<HTMLHeadingElement, SectionHeadingProps>(
  ({ className, ...props }, ref) => (
    <h2 ref={ref} className={cn(typography.sectionTitle, className)} {...props} />
  ),
);
SectionTitle.displayName = 'SectionTitle';

export function Eyebrow({ className, ...props }: ParagraphProps) {
  return <p className={cn(typography.eyebrow, className)} {...props} />;
}

export function BodyText({ className, ...props }: ParagraphProps) {
  return <p className={cn(typography.body, className)} {...props} />;
}

export function CaptionText({ className, ...props }: ParagraphProps) {
  return <p className={cn(typography.caption, className)} {...props} />;
}

export function MetricText({ className, ...props }: ParagraphProps) {
  return <p className={cn(typography.metric, className)} {...props} />;
}
